import { Capacitor, CapacitorHttp } from '@capacitor/core';

/**
 * Tope HTTP en vuelo por app (3): 6 vendedores + admin + oficina + 3 bodega en hosting ~20.
 */
const MAX_IN_FLIGHT = 3;
let inFlight = 0;
const waitQueue = [];

function pump() {
  while (inFlight < MAX_IN_FLIGHT && waitQueue.length) {
    const next = waitQueue.shift();
    next();
  }
}

function runGated(work) {
  return new Promise((resolve, reject) => {
    const start = () => {
      inFlight += 1;
      Promise.resolve()
        .then(work)
        .then(resolve, reject)
        .finally(() => {
          inFlight -= 1;
          pump();
        });
    };
    if (inFlight < MAX_IN_FLIGHT) start();
    else waitQueue.push(start);
  });
}

/** Respuesta tipo fetch a partir de CapacitorHttp. */
function toFetchLike(res) {
  const status = Number(res?.status) || 0;
  let parsed = res?.data;
  if (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed || '{}');
    } catch {
      parsed = {};
    }
  }
  return {
    ok: status >= 200 && status < 300,
    status,
    json: async () => parsed ?? {},
  };
}

/**
 * En APK usa HTTP nativo (CapacitorHttp) — más estable que el WebView en tablets viejas.
 * Si falla, cae a fetch.
 */
export function gatedFetch(url, options = {}) {
  return runGated(async () => {
    const method = String(options.method || 'GET').toUpperCase();
    const headers = { ...(options.headers || {}) };

    if (Capacitor.isNativePlatform()) {
      try {
        let data;
        if (options.body != null && options.body !== '') {
          try {
            data = typeof options.body === 'string' ? JSON.parse(options.body) : options.body;
          } catch {
            data = options.body;
          }
        }
        const res = await CapacitorHttp.request({
          url,
          method,
          headers,
          data,
          connectTimeout: 25000,
          readTimeout: 25000,
        });
        return toFetchLike(res);
      } catch {
        /* fallback WebView fetch */
      }
    }

    return fetch(url, options);
  });
}
